module.exports = __webpack_public_path__ + "static/media/video-bg.955c5566.jpg";